mod.modules.define("ListSection", "BaseSection", function (fn) {
	"use strict";

	// Handle filter/export buttons

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.CustomColumnsPlugin = this.addPlugin("Plugin-CustomColumns", {
			tableId: params.customizeColumnsId,
			maxColumns: 6
		});

        // Set some local references
		this.ScreenerUtilNamespace = (typeof (WSOD.ScreenerUtility) == "undefined") ? window : WSOD;
		this.ScreenerUtilityInstance = this.ScreenerUtilNamespace.ScreenerUtility.CreateInstance();
		this.ScreenerInputs = new this.ScreenerUtilNamespace.ScreenerUtility.ScreenInputs();

	    // Setup the paging inputs
		this.ScreenerInputs.SetFirstRow(0);
		this.pageSize = $('.num-results-selector option:selected').text();
		this.ScreenerInputs.SetRowCount(this.pageSize);

	    // Set the id
		var screenerId = $('[data-screenerid]').attr("data-screenerid");
		this.ScreenerInputs.SetScreenerID(screenerId);

		this.ScreenerUtilityInstance.SetInputs(this.ScreenerInputs)

		//VL-276 - one trick here is that this file is common to pages that need it and some that do not.
		mod.observer.trigger("section loaded", "ListSection", null);
	
		// Init the tooltips
		this.el.find("span.icon-pdf.off[rel=tooltip]").tooltip({
			maxWidth: 215
		});
		
	};

	fn.prototype.buildScreenInputs = function (resultFields) {

        //add screener arguments
	    var screenerArguments = eval($('.screener-results-header').attr('data-screener-args'));
	    for (var i = 0; i < screenerArguments.length; i++) {

	        var Arg = new this.ScreenerUtilNamespace.ScreenerUtility.Argument();
	        Arg.Parse(screenerArguments[i], null);
	        this.ScreenerInputs.AddArgument(Arg);
	    }

        //add sort arguments
	    var sortArguments = eval($('.screener-results-header').attr('data-screener-sort'));
	    var sortArgs = [];
	    for (var i = 0; i < sortArguments.length; i++) {
	        var arg = new this.ScreenerUtilNamespace.ScreenerUtility.ScreenInputs.SortArgument(sortArguments[i].Field, sortArguments[i].Direction);
	        sortArgs.push(arg);
	    }
	    this.ScreenerInputs.SetSortArguments(sortArgs);
	    
        //add result fields
	    this.ScreenerInputs.SetResultFields(eval($('.screener-results-header').attr('data-screener-results')));

	};

	fn.prototype.observables = {
		"list changed": function(listId) {
			this.reloadQueue({
				ListId: listId
			});
		},
		"custom columns saved": function() {
			this.reload();
		},
		//This will show the dialog if needed. (VL-276)
		"section loaded": function () {
			if ($("body .modal-backdrop").length >0) {
				$("body .modal-backdrop").remove();
			}
				var $showNewsDialog = $("#screener_new_columns_screen");
				if ($showNewsDialog.length > 0) {
					$showNewsDialog.modal({
						backdrop: "static", // Prevent the modal from closing on blur
						show: false
					}).modal("show");
			}
			
			
		}
	};
     
	fn.prototype.downloadResults = function (type, callback) {

	    this.buildScreenInputs();
	    var inputString = JSON.stringify(this.ScreenerUtilityInstance.GetInputs(true));

	    var $form = $("#postingForm");
	    $form.find("input[name=inputs]").val(inputString);
	    $form.find("input[name=type]").val(type);
	    $form.submit();

	    if (callback) {
	        callback();
	    }
	};

	//VL-276 this handler deals with the API check
	fn.prototype.handlePDFClickResult = function (response, status, request) {
		if (response) {
			if (/true/i.test(response.success)) {
				var docURL = response.message;
				if (docURL != null && docURL != "") {
					docURL = docURL.resolveUrl();

					if (docURL.indexOf("secure/secure") > 0) {
						docURL = docURL.replace("secure/secure", "secure");
					}
				}

				window.open(docURL, "_blank");
			} else {
				alert(response.message);
			}
		} else {
			alert("Sorry, something went wrong with your document request.");
		}
	};

	fn.prototype.events = {
		"button[data-action=customize-columns]": {
			"click": function() {
				this.CustomColumnsPlugin.showModal();
			}
		},
		"button[data-action=download-data]": {
		    "click": function (e, $el) {
		        $("#screener_download").modal();
		    }
		},
		"[data-action=download-screen]": {
		    "click": function (e, $el) {

		        var $modal = $el.closest('div.modal-body');
		        var $selectedInput = $modal.find('div.config-section input:checked');
		        var selectedType = $selectedInput.val();

		        // Kick off the download
		        this.downloadResults(selectedType, function () {
		            $("#screener_download").modal("hide");
		        });
		    }
		},
		"div.modal [data-action=cancel]": {
		    "click": function (e, $el) {
		        $el.closest("div.modal").modal("hide");
		    }
		},
		//VL-276 added for handling our dialog.
		"div.modal [data-action=dismiss-new-columns-screen]": {
			"click": function (e, $el) {
				var $target = $(e.target);
				if ($target.is("div.modal") == false) {
					$target = $target.closest("div.modal")
				}
				var modalId = $target.attr("id");
				var $dialog = $("#" + modalId)

				//Check to see if our checkbox is checked
				var $dontShowAgain = $("input[name=dontShowAgain]:checked", $dialog);
				if ($dontShowAgain.length > 0) {
					//alert("Finish this with a call to ResearchController/SetDontShowScreenerNewsModal");
					$.ajax({
						url: "~/Research/SetDontShowScreenerNewsModal".resolveUrl(),
						type: "post",
						dataType: "json",
						data: {
							dontShowAgain: ($dontShowAgain.length > 0)
						},
						context: this,
						success: function () {
						},
						error: function error() {
							alert("There was an error when trying to save your preference.");
						}
					});
				}

				//hide the dialog
				$dialog.modal("hide");
				$("body .modal-backdrop").remove();

			}
		},
		//VL-276 added for handling our PDF links.
		"a.industryReportPDF, a.stockReportPDF": {
			"click": function (e, $el) {
				var $target = $(e.target);
				if ($target.is("A") == false) {
					$target = $target.closest("A")
				}
				var apiURL = $target.attr("api");
				var docType = $target.attr("docType");
				var item = $target.attr("item");

				if (apiURL != null && apiURL != "") {
					apiURL = apiURL.resolveUrl();

					if (apiURL.indexOf("secure/secure") > 0) {
						apiURL = apiURL.replace("secure/secure", "secure");
					}
				}

				var postData = {
					itemQuery: item,
					docType: docType
				};
				
				$.ajax({
					url: apiURL,
					type: "post",
					dataType: "json",
					data: postData,
					context: this,
					success: $.proxy(this.handlePDFClickResult, this),
					error: function error() {
						alert("There was an error when trying to get your document.");
					}
				});
			}
		}
	};

});